// client/src/coms/components/comslayout_parts/useSidebarResize.js
import { useRef, useState } from 'react';
import { clamp, getComsSidebarWidth, setComsSidebarWidthPersist } from './layoutUtils';

const SIDEBAR_MIN_WIDTH = 350;
const SIDEBAR_DEFAULT_WIDTH = 450;
const SIDEBAR_MAX_WIDTH = 550;

export default function useSidebarResize() {
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const saved = getComsSidebarWidth();
    if (Number.isFinite(saved)) return clamp(saved, SIDEBAR_MIN_WIDTH, SIDEBAR_MAX_WIDTH);
    return SIDEBAR_DEFAULT_WIDTH;
  });

  const draggingSidebarRef = useRef(false);
  const sidebarStartXRef = useRef(0);
  const sidebarStartWRef = useRef(SIDEBAR_DEFAULT_WIDTH);
  const liveWidthRef = useRef(sidebarWidth);

  function onStartResizeSidebar(e) {
    if (!e) return;

    draggingSidebarRef.current = true;
    sidebarStartXRef.current = e.touches ? e.touches[0].clientX : e.clientX;
    sidebarStartWRef.current = liveWidthRef.current;

    try {
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    } catch {}

    function onMove(ev) {
      if (!draggingSidebarRef.current) return;

      const x = ev.touches ? ev.touches[0].clientX : ev.clientX;
      const dx = x - sidebarStartXRef.current;
      const next = clamp(sidebarStartWRef.current + dx, SIDEBAR_MIN_WIDTH, SIDEBAR_MAX_WIDTH);

      liveWidthRef.current = next;
      setSidebarWidth(next);
    }

    function onUp() {
      if (!draggingSidebarRef.current) return;

      draggingSidebarRef.current = false;
      setComsSidebarWidthPersist(liveWidthRef.current);

      try {
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
      } catch {}

      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
    }

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onUp);
  }

  return { sidebarWidth, setSidebarWidth, onStartResizeSidebar };
}